import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetUserInput } from './GetUserInput';
import { GetUserOutput } from './GetUserOutput';

export class GetUserService extends HttpServiceBase {

    handle = (input: GetUserInput): Promise<Result<GetUserOutput>|null> => {
        const promise = this.http.post<Result<GetUserOutput>, GetUserInput>(`${this.baseUrlSislogApi}/user/auth`, input);
        return promise;
    }
}